import { compose, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./rootReducer";
import { sessionService } from "redux-react-session";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const composeEnhancers =
    process.env.NODE_ENV === "development"
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
        : compose;
const persistConfig = {
    key: "root",
    storage,
    whitelist: ["dashboard"],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(thunk))
);

const persistor = persistStore(store);

const validateSession = (session) => {
    return true;
};

const options = {
    refreshOnCheckAuth: true,
    redirectPath: "/",
    driver: "COOKIES",
    expires: null,
    validateSession,
};
sessionService.initSessionService(store, options);

export { store, persistor };
